import { useMemo, useState } from "react";
import type { IIcon } from ".";

export const useIconsGroup = (icons: IIcon[], limit: number) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const { displayedIcons, hiddenIcons } = useMemo(() => {
    const displayedIcons: IIcon[] = [];
    const hiddenIcons: IIcon[] = [];
    if (icons.length === limit + 1) {
      return { displayedIcons: [...icons], hiddenIcons: [] };
    }
    for (const [index, value] of icons.entries()) {
      if (!value.hidden) {
        if (index < limit) {
          displayedIcons.push(value);
        } else {
          hiddenIcons.push(value);
        }
      }
    }
    return { displayedIcons, hiddenIcons };
  }, [icons, limit]);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return {
    displayedIcons,
    hiddenIcons,
    anchorEl,
    handleOpen,
    handleClose,
  };
};
